import { ActivityIndicator, Dimensions, FlatList, Image, Modal, PixelRatio, Platform, ScrollView, StyleSheet, Text, View } from 'react-native'
import * as ImagePicker from 'expo-image-picker';
import * as FileSystem from 'expo-file-system';
import React, { useEffect, useState } from 'react'
import { TouchableOpacity } from 'react-native'
import Colours from '../../utils/Colours';
import ErrorAlertComp from '../../alertComp/ErrorAlertComp';
import SuccessAlertComp from '../../alertComp/SuccessAlertComp';
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent';
import AppTextInput from '../../utils/ColourThemes/AppTextInput';
import PostToPullandTable from '../homeScreen/PostToPullandTable';
import { ImageManipulator } from 'expo-image-manipulator';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGES = 2;
const MAX_IMAGE_SIZE_MB = 3;
const MAX_IMAGE_SIZE_MB_COMPRESS = 1;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB_COMPRESS * 1024 * 1024;

const FeedBackSupport = ({ hideModal }) => {
    // const [image, setImage] = useState(null)
    const [images, setImages] = useState([])
    const [isPhotoClicked, setIsPhotoClicked] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [comment, setComment] = useState('')
    const [isLoading1, setIsLoading1] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [isLoading3, setIsLoading3] = useState(false)
    const [isSendPhotoClicked, setIsSendPhotoClicked] = useState(false)
    const [selectedPhoto, setSelectedPhoto] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [postToPullandTable, setShowPostToPullandTable] = useState(false)
    const [isCommentBoxClicked, setIsCommentBoxClicked] = useState(false)
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')

    const axiosPrivate = useAxiosPrivate()


    useEffect(() => {
        //console.log('images', images)
    }, [])

    const pickMultiImage = async (setImages, currentImages) => {
        try {
            setIsLoading(true);

            const result = await ImagePicker.launchImageLibraryAsync({
                mediaTypes: ['images'],
                allowsEditing: false,
                allowsMultipleSelection: true,
                aspect: [4, 4],
                quality: 1,
            });

            if (result.canceled) return;

            const newAssets = result.assets || [];
            const newImageURIs = [];

            for (let asset of newAssets) {
                const fileInfo = await FileSystem.getInfoAsync(asset.uri);
                const fileSizeInMB = fileInfo.size / (1024 * 1024);

                //console.log(`Selected image size: ${fileSizeInMB.toFixed(2)} MB`);

                if (fileSizeInMB > MAX_IMAGE_SIZE_MB) {
                    setErrorMessage(
                        `Image too large: The selected image is ${fileSizeInMB.toFixed(
                            2
                        )} MB. Please choose one below ${MAX_IMAGE_SIZE_MB}MB.`
                    );
                    setIsErrorCompVisible(true);
                    setSelectedPhoto(false);
                    setIsLoading(false);
                    return; // Stop processing if any image is too large
                }

                newImageURIs.push(asset.uri);
            }

            const totalImages = [...currentImages, ...newImageURIs];

            if (totalImages.length > MAX_IMAGES) {
                setErrorMessage(`You can only select up to ${MAX_IMAGES} images.`);
                setIsErrorCompVisible(true);
                setImages(currentImages); // Keep the previous state unchanged
                setSelectedPhoto(true);
            } else {
                setImages(totalImages);
                setSelectedPhoto(true);
            }

        } catch (error) {
            //console.error('Error picking image:', error);
            setErrorMessage('An error occurred while selecting images.');
            setIsErrorCompVisible(true);
        } finally {
            setIsLoading(false);
        }
    };


    const prepareImageForUpload = async (imageUri) => {
        try {
            const fileInfo = await FileSystem.getInfoAsync(imageUri);

            if (fileInfo.size && fileInfo.size <= MAX_IMAGE_SIZE_BYTES) {
                // Already under 1MB, return as-is
                //console.log(`Image is already ${Math.round(fileInfo.size / 1024)} KB`);
                return imageUri;
            }

            //console.log(`Image too large: ${Math.round(fileInfo.size / 1024)} KB, compressing...`);
            let compressRatio = 0.9;
            let compressed = null;

            while (compressRatio > 0.1) {
                compressed = await ImageManipulator.manipulateAsync(
                    imageUri,
                    [],
                    {
                        compress: compressRatio,
                        format: ImageManipulator.SaveFormat.JPEG,
                    }
                );

                const compressedInfo = await FileSystem.getInfoAsync(compressed.uri);

                if (compressedInfo.size && compressedInfo.size <= MAX_IMAGE_SIZE_BYTES) {
                    //console.log(`Compressed to ${Math.round(compressedInfo.size / 1024)} KB`);
                    return compressed.uri;
                }

                compressRatio -= 0.1;
            }

            //console.warn('Could not get image under 1MB. Returning best attempt.');
            return compressed ? compressed.uri : imageUri;

        } catch (error) {
            //console.error('Image compression failed:', error);
            return imageUri; // fallback to original
        }
    };

    const prepareImagesForUpload = async (imageUris) => {
        const compressedImages = await Promise.all(
            imageUris.map((uri) => prepareImageForUpload(uri))
        );
        return compressedImages;
    };


    const handleSendFeedBack = async () => {
        if (comment == '') {
            setIsCommentBoxClicked(true)
        } else {
            handlePostFeedBackTo_db()
        }
    }

    const handleCommentsForm = (text) => {
        setComment(text)
        //console.log('Comment', text)

    }

    const handlePostFeedBackTo_db = async () => {

        const formData = new FormData()

        try {
            setIsLoading2(true)

            let processedImages = [];

            if (Array.isArray(images) && images.length > 0) {
                processedImages = await prepareImagesForUpload(images);
                //console.log('Compressed Images:', processedImages);

                processedImages.forEach((uri, index) => {
                    const uriParts = uri.split('.');
                    const fileType = uriParts[uriParts.length - 1].toLowerCase();

                    formData.append('images', {
                        uri: Platform.OS === 'ios' ? uri.replace('file://', '') : uri,
                        type: `image/${fileType}`,
                        name: `photo_${index + 1}.${fileType}`,
                    });
                });

            }

            formData.append('comment', comment);

            // **Proceed to submit to the database**
            setIsLoading2(true);

            const feedbackResponse = await axiosPrivate.post('/feedback/feedback', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (feedbackResponse.status === 200 || feedbackResponse.status === 201) {
                // setIsNoticeAlertVisible(false)
                setSuccessMessage(feedbackResponse.data.message)
                setIsSuccessCompVisible(true)
                setComment('')
                setImages([])
                // hideModal(true)

            } else {
                //  setIsNoticeAlertVisible(false)
                setErrorMessage('Unexpected response')
                setIsErrorCompVisible(true)
            }
        } catch (error) {
            //console.log('Errors', error)
            if (error.response) {
                //console.error('Error response from server:', error.response.data);
                // setIsNoticeAlertVisible(false)
                const errorMessages = error.response.data?.error || error.response.data?.message || 'Something went wrong';
                setErrorMessage(errorMessages);
                setIsErrorCompVisible(true);

            }
            else if (error.request) {
                //console.error('No response received:', error.request);
                // setIsNoticeAlertVisible(false)
                setErrorMessage('No response Recieved check your internet')
                setIsErrorCompVisible(true)
            }
            else {
                //console.error('Error setting up the request:', error.message);
                // setIsNoticeAlertVisible(false)
                setErrorMessage(error.message || 'Unexpected error occurred')
                setIsErrorCompVisible(true)
            }

        } finally {
            setIsLoading2(false);


        }
    }

    return (
        <ScrollView
            style={styles.componentStyle}
            contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
            showsVerticalScrollIndicator={false}
        >
            <View>
                <AppTextInput
                    style={[styles.commentBox, isCommentBoxClicked && styles.focusedBorder,
                        //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                    ]}
                    placeholder="Drop a comment:"
                    numberOfLines={3}
                    multiline
                    onFocus={() => setIsCommentBoxClicked(true)}
                    onBlur={() => setIsCommentBoxClicked(false)}
                    // value={tableCaption}
                    onChangeText={handleCommentsForm}
                    maxLength={200}
                />

                <TouchableOpacity
                    style={[styles.photoViewStyle, isPhotoClicked && styles.focusedBorder]}
                    onPress={() => pickMultiImage(setImages, images)}
                    onPressIn={() => setIsPhotoClicked(true)}
                    onPressOut={() => setIsPhotoClicked(false)}
                >

                    {isLoading ? (<View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
                    </View>
                    ) : (
                        <>
                            <Text style={styles.photoTxt}>Select Photos:</Text>

                            {images && images.length > 0 ? (
                                // <Image style={styles.imageStyle} source={{ uri: image }} />
                                <FlatList
                                    data={images}
                                    horizontal
                                    // keyExtractor={(item) => item._id.toString()}
                                    keyExtractor={(item, index) => item + index}
                                    renderItem={({ item, index }) => (
                                        isLoading3[index] ? (
                                            <View style={styles.imageStyle}>
                                                <ActivityIndicator size="small" color={Colours.PRIMARY} />
                                            </View>
                                        ) : (
                                            <TouchableOpacity
                                                onPress={() => {

                                                    handleChangeImage(index);

                                                }}
                                            >
                                                <Image
                                                    style={styles.imageStyle}
                                                    source={{ uri: item }}
                                                />
                                            </TouchableOpacity>
                                        )
                                    )}
                                />
                            ) : (
                                <Image style={styles.imageStyle} source={require('../../../assets/imagePlaceholder.jpg')} />
                            )}
                        </>
                    )}
                </TouchableOpacity>

                <TouchableOpacity style={[styles.sendPhotoButton, {

                    backgroundColor: isSendPhotoClicked ? Colours.PRIMARY : Colours.DARKGRAY,
                    //opacity: selectedPhoto ? 1 : 0.5,
                }]}
                    onPress={handleSendFeedBack}
                    disabled={isLoading2}
                >
                    {isLoading2 ? (
                        <ActivityIndicator size="small" color="white" />
                    ) : (
                        <Text style={styles.openCreatTxt}>
                            Send
                        </Text>
                    )}
                </TouchableOpacity>

                {/* <Modal
                    visible={isSuccessAlertCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <SuccessAlertComp
                        message={successMessage}
                        onClose={handleCloseModal}
                    />
                </Modal> */}
                <Modal
                    visible={isErrorCompVisible}
                    transparent={true}
                    animationType="fade"
                    onRequestClose={() => setIsErrorCompVisible(false)}
                >
                    <ErrorAlertComp
                        message={errorMessage}
                        onClose={() => setIsErrorCompVisible(false)}
                    />
                </Modal>


                <Modal
                    visible={isSuccessCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <SuccessAlertComp
                        message={successMessage}
                        onClose={() => {
                            setIsSuccessCompVisible(false)
                            setComment('')
                            hideModal(true)
                        }}
                    />
                </Modal>
            </View>
        </ScrollView>
    )
}

export default FeedBackSupport

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        display: 'flex',
        // margin: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        //borderRadius: dynamicSize(15),
        height: '100%',
    },
    photoViewStyle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: dynamicSize(60),
        width: '100%',
        marginTop: dynamicSpacing(10),
        paddingLeft: dynamicSpacing(10),
        paddingRight: dynamicSpacing(10),
        borderWidth: dynamicSize(2),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        marginBottom: dynamicSpacing(5),
        backgroundColor: Colours.LIGHTGRAY,
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    photoTxt: {
        marginRight: dynamicSpacing(100),
        color: Colours.DARKLIGHTGRAY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Regular',

    },
    imageStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: dynamicSize(45),
        height: dynamicSize(40),
        borderRadius: dynamicSize(10),
        marginLeft: dynamicSpacing(5)
    },
    sendPhotoButton: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
    openCreatTxt: {
        fontSize: dynamicFontSize(15),
        color: 'white',
        fontFamily: 'Sen-Bold',
    },
    commentBox: {
        height: dynamicSize(100),
        width: '100%',
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSize(2),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(5),

        textAlignVertical: 'top',
        textAlign: 'left',
    },

    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },

})